export default __webpack_public_path__ + "static/media/paper-load2.300d1bde.svg";